<template>
    <b-modal id="modal-company-id" no-close-on-esc centered no-close-on-backdrop
      :footer-class="'d-block p-3 m-0'" @shown="setCompanyIDField">
      <template #modal-header="{ close }">
        <h5 class="modal-title">
            {{ $t('companyId.title') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          Close Modal
        </b-button>
      </template>

      <div class="text-center">
        <b-form-group label="" class="text-left">
          <b-form-input type="text" :placeholder="$t('companyId.placeholder')" required
            v-model="new_company_id" />
          <p v-if="errors && errors.new_company_id" class="field-error">
            {{ errors.new_company_id[0] }}
          </p>
        </b-form-group>
      </div>
      <template #modal-footer>
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 mx-0">
          <b-button class="mx-0 mr-3 h-40px w-100px m-0" @click="resetPopup()" variant="secondary">{{ $t('companyId.cancel') }}</b-button>
          <div class="d-flex align-items m-0">
            <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary"
              @click="setCompanyID">{{ $t('companyId.save') }}</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </template>
  <script>
  import { mapActions, mapGetters } from 'vuex';
  export default {
    name: "CompanyIdPopup",
    data() {
      return {
        new_company_id: "",
        errors: {}
      }
    },
    computed: {
      ...mapGetters(["company", 'userCompany'])
    },
    methods: {
      ...mapActions(["setLoader", 'updateCompanyID', 'setNotification',"getCompany"]),
      resetPopup() {
        this.$bvModal.hide('modal-company-id');
        this.new_company_id = ""
      },
      async setCompanyID() {
        try {
          this.errors = {}
          const nullKeys = this.checkNullValues({
            new_company_id: this.new_company_id,
          });
          if (nullKeys.length === 0) {
            this.setLoader(true)
            await this.updateCompanyID({new_company_id:this.new_company_id});
            await this.setNotification({
              msg: this.$t('companyId.updated'),
              type: "success",
              color: "green",
            });
            await this.getCompany()
            this.setLoader(false)
            this.resetPopup()
          }
          else {
            let error = {};
            nullKeys.forEach((x) => {
              error[x] = [this.$t('companyId.fieldRequired')];
            });
            throw error;
          }
        }
        catch (error) {
          this.setLoader(false)
          if (typeof error === "object" && error.error) {
            await this.setNotification({
              msg: error.error,
              type: "error",
              color: "red",
            });
          }
          else if (typeof error === "object") {
            this.errors = error;
          }
        }
      },
      checkNullValues(payload) {
        let nullKeys = [];
        for (let [key, value] of Object.entries(payload)) {
          if (value === "") {
            nullKeys.push(key);
          }
        }
        return nullKeys;
      },
      setCompanyIDField(){
        this.new_company_id = this.company[0].company_ID

      }
    },
  }
  </script>